import React, { Component } from "react";
import style from "./CreateInvoiceSupplier.module.css";
//import DatePicker from "react-datepicker";
import { DatePicker } from "antd";
import moment from "moment";
import { Button } from "reactstrap";
import api from "../../../utils/Api";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import {
  checkIfPermitted,
  Permissions,
} from "../../../services/RolePermissionService";
import { Select } from "antd";
import { connect } from "react-redux";
import { fetchproduct } from "../../../redux";
import { formatNumberToCurrency } from "../../../utils/CommonUtil";
import { NAME_MESSAGE, NAME_REGEX } from "../../../utils/RegexConstants";
const { Option } = Select;

export class CreateInvoiceSupplier extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      address: "",
      date: "",
      isInventory: true,
      product_name: "",
      inputList: [
        {
          inventory_id: "",
          product_name: "",
          quantity: "",
          unit_price: "",
          amount: "",
        },
      ],
      sub_total: 0,
      vat_amount: 0,
      vat_percent:
        localStorage.getItem("SETTING_INFO") &&
        JSON.parse(localStorage.getItem("SETTING_INFO")).vat_percent,
      total: 0,
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      error: "",
      emailError: "",
      isScreenLoaded: false,
      isValid: "",
      isNameCharOnly: "",
      isAmountOnly: [],
      isUnitPriceOnly: [],
    };
  }

  componentDidMount = async () => {
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 2000);

    // fetching product autocomplete
    await this.props.fetchproduct(this.state.product_name);
  };

  handleChange = (event) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
    if (name === "email") {
      this.validateEmail(val);
    }
    if (name === "name") {
      this.isNameCharOnly(event);
    }
  };

  //email validation
  validateEmail = (email) => {
    const pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const result = pattern.test(email);
    if (result === true) {
      this.setState({
        emailError: false,
      });
    } else {
      this.setState({
        emailError: true,
      });
    }
  };

  // Validations for character only
  isNameCharOnly = (event) => {
    const regex = NAME_REGEX;
    if (!regex.test(event.target.value)) {
      this.setState({
        isNameCharOnly: NAME_MESSAGE,
      });
    } else {
      this.setState({
        isNameCharOnly: "",
      });
    }
  };

  // Input handle changes
  handleChangeDate = (date) => {
    this.setState({
      date: date,
    });
  };

  // product autocomplete input handle
  onChange = (value, event) => {
    console.log(`selected ${value}`);
  };

  onSearch = async (val) => {
    console.log("search:", val);
    // Fetch product autocomplete api
    await this.props.fetchproduct(val);
    this.setState({
      product_name: val,
    });
  };

  handleOnSelect = (value, event, index) => {
    console.log("++++++++++++++++ Hey buddy - ", event);
    const list = [...this.state.inputList];
    list[index]["product_name"] = event.children;
    list[index]["inventory_id"] = event.value;
    this.setState({
      inputList: list,
    });
  };

  // common diagnosis handlechange
  handleInputChange = (event, index) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
    const list = [...this.state.inputList];
    list[index][name] = val;
    this.setState({
      inputList: list,
    });
    if (name === "quantity" || name === "unit_price") {
      const quantity = name === "quantity" ? val : list[index]["quantity"];

      const unit_price =
        name === "unit_price" ? val : list[index]["unit_price"];
      list[index]["amount"] = quantity * unit_price;
      this.setState(
        {
          inputList: list,
        },
        () => {
          const sum_amount =
            this.state.inputList &&
            this.state.inputList
              .map((item) => item.amount)
              .reduce((prev, curr) => prev + curr, 0);

          const vat_calc = sum_amount * (this.state.vat_percent / 100);
          console.log("vat_calc", vat_calc);

          const total_amount = sum_amount + vat_calc;
          this.setState({
            sub_total: sum_amount,
            vat_amount: vat_calc,
            total: total_amount,
          });
        }
      );
    }
    if (name === "quantity") {
      let amountError = [...this.state.isAmountOnly];
      const quantity = name === "quantity" ? val : list[index]["quantity"];
      const regex = /^[0-9]*$/;
      if (!regex.test(list[index]["quantity"])) {
        amountError[index] = "Enter only numbers";
      } else {
        amountError[index] = "";
      }
      this.setState({
        isAmountOnly: amountError,
      });
    }
    if (name === "unit_price") {
      let unitPriceError = [...this.state.isUnitPriceOnly];
      const unit_price =
        name === "unit_price" ? val : list[index]["unit_price"];
      const regex = /^[0-9]*$/;
      if (!regex.test(list[index]["unit_price"])) {
        unitPriceError[index] = "Enter only numbers";
      } else {
        unitPriceError[index] = "";
      }
      this.setState({
        isUnitPriceOnly: unitPriceError,
      });
    }
  };

  // Validations for only numbers allowed
  validateNumbersOnlyA = (e) => {
    const regex = /^[0-9]*$/;

    if (!regex.test(e.target.value)) {
      this.setState({
        isAmountOnly: "Enter only numbers",
      });
    } else {
      this.setState({
        isAmountOnly: "",
      });
    }
  };

  // handleBlur
  handleBlurChange = () => {
    if (
      this.state.name !== "" &&
      this.state.address !== "" &&
      this.state.date !== ""
    ) {
      this.setState({
        error: "",
      });
    }
  };

  handleRemoveClick = (index) => {
    const list = [...this.state.inputList];
    list.splice(index, 1);
    this.setState({
      inputList: list,
    });
  };

  handleAddClick = () => {
    this.setState((prevState) => ({
      inputList: [
        ...this.state.inputList,
        {
          inventory_id: "",
          product_name: "",
          quantity: "",
          unit_price: "",
          amount: "",
        },
      ],
    }));
  };

  // Validations for products
  productsIsValid = () => {
    for (let i = 0; i < this.state.inputList.length; i++) {
      if (
        this.state.inputList[i].amount === "" ||
        this.state.inputList[i].product_name === "" ||
        this.state.inputList[i].quantity === "" ||
        this.state.inputList[i].unit_price === ""
      ) {
        this.setState({
          isValid: false,
        });
      } else {
        this.setState({
          isValid: true,
        });
      }
    }
  };

  // Send party and doctor data to receive payment
  onCreateInvoiceSubmit = async () => {
    await this.productsIsValid();
    if (
      this.state.name === "" ||
      this.state.email === "" ||
      this.state.address === "" ||
      this.state.date === "" ||
      this.state.date === null ||
      this.state.isValid === false
    ) {
      this.setState({
        error: "Please filled out all mandatory field",
      });
    } else {
      this.setState({
        error: "",
      });
      let quantittError = this.state.isAmountOnly.find((ele, index) => {
        return ele !== "undefind";
      });
      let priceError = this.state.isUnitPriceOnly.find((ele, index) => {
        return ele !== "undefind";
      });

      if (
        this.state.emailError === false &&
        this.state.isNameCharOnly === "" &&
        quantittError === "" &&
        priceError === ""
      ) {
        this.setState({
          isLoading: true,
        });
        // Payload to be sent
        const payload = {
          isInventory: this.state.isInventory,
          sub_total: this.state.sub_total,
          vat_amount: this.state.vat_amount,
          total: this.state.total,
          vat_percent: this.state.vat_percent,
          billTo: this.state.name,
          billing_email: this.state.email,
          invoice_date: moment(this.state.date).format("YYYY-MM-DD"),
          inventory: this.state.inputList,
          invoice_list_type:3
        };
        //console.log("**********", payload);

        // Headers
        const headers = {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
        try {
          const response = await api.post("payment/invoice/save", payload, {
            headers: headers,
          });
         // console.log("************response", response.data.data.invoice_id);
          if (response.status === 200) {
            this.setState({
              isLoading: false,
              successMessage: "Invoice created successfully",
            });
            setTimeout(() => {
              this.setState({
                successMessage: "",
              });
              if (checkIfPermitted(Permissions.VIEW_INVOICE)) {
                this.props.history.push({
                  pathname: "/app/invoicedetails",
                  state: {
                    invoice_id: response.data.data.invoice_id,
                    isFromSupplier: true,
                  },
                });
              }
            }, 2000);
          }
        } catch (error) {
          if (error.response) {
            this.setState({
              isLoading: false,
              errorMessage: "Internal server error occured",
            });
            setTimeout(() => {
              this.setState({
                errorMessage: "",
              });
            }, 2000);
          }
          console.log("Crate room error", error);
        }
      }
    }
  };

  render() {
    // Product autocomplete data
    console.log(
      "Product data in component",
      this.props.productData && this.props.productData.product
    );
    const productOptionsData =
      this.props.productData &&
      this.props.productData.product.map((element, index) => {
        return (
          <option key={index} value={element.inventory_id}>
            {element.product_name}
          </option>
        );
      });
    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
    return (
      <div>
        <div className={style.createInvoiceWrapper}>
          <div className="row">
            <div className="col-lg-12">
              <h3>Create Invoice (Product)</h3>
            </div>
            <div className="col-lg-12 intro-text">
              <p className="mb-4">
              This Create Invoice feature is not associated with any appointment and will be used by practices that sell products as part of their offering. 
              The Invoice must be used to provide a customer with a quotation of the price of a product(s).
              </p>
          </div>
          </div>
          <form>
            <div className="form-box-shadow">
              <div className="row">
                <div className="col-lg-12">
                  <h6>Invoice Details</h6>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="form-group">
                    <label htmlFor="name">
                      Name:{" "}
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Name"
                      onChange={this.handleChange}
                      className={`form-control ${
                        this.state.isNameCharOnly ? "is-invalid" : ""
                      }`}
                    />
                    {this.state.isNameCharOnly && (
                      <span className="error">{this.state.isNameCharOnly}</span>
                    )}
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="form-group">
                    <label htmlFor="address">
                      Address:{" "}
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="address"
                      name="address"
                      placeholder="Address"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="form-group">
                    <label htmlFor="email">
                      Email:
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <input
                      type="email"
                      className={`form-control ${
                        this.state.emailError ? "is-invalid" : ""
                      }`}
                      id="email"
                      name="email"
                      placeholder="Email"
                      value={this.state.email}
                      onChange={this.handleChange}
                      onBlur={this.handleBlurChange}
                    />
                    {this.state.emailError ? (
                      <span className="error">
                        Please Enter valid email address
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                  <div className="form-group">
                    <label htmlFor="date">
                      Date:{" "}
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <DatePicker
                      selected={
                        this.state.date ? new Date(this.state.date) : null
                      }
                      onChange={this.handleChangeDate}
                      className="form-control"
                      id="date"
                      name="date"
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Date"
                    />
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table invoice-table">
                  <thead>
                    <tr>
                      <th>
                        Product Name{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </th>
                      <th>
                        Quantity{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </th>
                      <th>
                        Unit Price (ZAR){" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </th>
                      <th>
                        Amount (ZAR){" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.inputList.map((x, i) => {
                      return (
                        <React.Fragment>
                          <tr key={i}>
                            <td style={{ width: 250 }}>
                              <div className="form-group">
                                {/* <input
                                  type="text"
                                  className="form-control"
                                  name="product_name"
                                  placeholder="Product Name"
                                  onChange={(e) => this.handleInputChange(e, i)}
                                /> */}

                                <Select
                                  showSearch
                                  allowClear={true}
                                  placeholder="Search a product"
                                  optionFilterProp="children"
                                  style={{ width: 250 }}
                                  onChange={this.onChange}
                                  onSelect={(value, event) =>
                                    this.handleOnSelect(value, event, i)
                                  }
                                  onSearch={this.onSearch}
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                >
                                  {productOptionsData}
                                </Select>
                              </div>
                            </td>
                            <td>
                              <div className="form-group">
                                <input
                                  type="text"
                                  name="quantity"
                                  placeholder="Quantity"
                                  maxLength="4"
                                  onChange={(e) => this.handleInputChange(e, i)}
                                  className={`form-control ${
                                    this.state.isAmountOnly[i]
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                {this.state.isAmountOnly[i] && (
                                  <span className="error">
                                    {this.state.isAmountOnly[i]}
                                  </span>
                                )}
                              </div>
                            </td>
                            <td>
                              <div className="form-group">
                                <input
                                  type="text"
                                  name="unit_price"
                                  placeholder="Unit Price"
                                  maxLength="10"
                                  onChange={(e) => this.handleInputChange(e, i)}
                                  className={`form-control ${
                                    this.state.isUnitPriceOnly[i]
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                {this.state.isUnitPriceOnly[i] && (
                                  <span className="error">
                                    {this.state.isUnitPriceOnly[i]}
                                  </span>
                                )}
                              </div>
                            </td>
                            <td>
                              <div className="form-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="amount"
                                  placeholder="Amount"
                                  //onChange={(e) => this.handleInputChange(e, i)}
                                  //value={this.state.total}
                                  value={
                                    formatNumberToCurrency(this.state.inputList[i].amount)
                                  }
                                  disabled
                                />
                              </div>
                            </td>
                            <td>
                              {this.state.inputList.length !== 1 && (
                                <i
                                  className={`fa fa-times ${style.deleteIcon}`}
                                  aria-hidden="true"
                                  onClick={(e) => this.handleRemoveClick(i)}
                                ></i>
                              )}
                            </td>
                          </tr>

                          {this.state.inputList.length - 1 === i && (
                            <div className="row mt-3">
                              <div className="col-lg-12">
                                <button
                                  type="button"
                                  onClick={this.handleAddClick}
                                  className="ttm-secondary-btn tmed-secondary-btn"
                                >
                                  <i
                                    className="fa fa-plus mr-2"
                                    aria-hidden="true"
                                  ></i>
                                  Add
                                </button>
                              </div>
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* <div style={{ marginTop: 20 }}>
                {JSON.stringify(this.state.inputList)}
              </div> */}

              <div className="row">
                <div className="col-12">
                  <div className={style.totalAmountWrapper}>
                    <p>
                      <span>Subtotal: </span>
                      <span>{formatNumberToCurrency(this.state.sub_total)}</span>
                    </p>
                    <p>
                      <span>{`VAT (${this.state.vat_percent}%): `}</span>
                      <span>{formatNumberToCurrency(this.state.vat_amount)}</span>
                    </p>
                    <p>
                      <span>Total: </span>
                      <span>{formatNumberToCurrency(this.state.total)}</span>
                    </p>
                  </div>
                </div>
              </div>

              {/* <div className="row">
                <div className="col-md-6 col-lg-8"></div>
                <div className="col-md-3 col-lg-2">
                  <div className={style.totalAmountWrapper}>
                    <p>Subtotal : </p>
                    <p>{`VAT ${this.state.vat_percent} % : `}</p>
                    <p>Total : </p>
                  </div>
                </div>
                <div className="col-md-3 col-lg-2">
                  <div className={style.totalAmountWrapper}>
                    <p>{this.state.sub_total}</p>
                    <p>{this.state.vat_amount}</p>
                    <p>{this.state.total}</p>
                  </div>
                </div>
              </div> */}
            </div>

            <div className="row">
              <div className="col-md-12">
                {this.state.error && (
                  <div className={`error ${style.errorText}`}>
                    {this.state.error}
                  </div>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                {this.state.isLoading ? (
                  <div className={style.loadingWrapper}>
                    <img src={ttmLoader} alt="loader" className={style.loading} />
                  </div>
                ) : (
                  <div>
                    {this.state.successMessage && (
                      <p className={style.successMessage}>
                        {this.state.successMessage}
                      </p>
                    )}
                    {this.state.errorMessage && (
                      <p className={style.errorMessage}>
                        {this.state.errorMessage}
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="row">
              <div
                className={`col-lg-12 d-flex justify-content-end flex-column-reverse flex-md-row align-items-center ${style.createInvoiceBtnWrapper}`}
              >
                <div>
                  <Button
                    type="button"
                    className="form-primary-btn"
                    onClick={this.onCreateInvoiceSubmit}
                  >
                    Create Invoice
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    productData: state.product,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchproduct: (productName) => dispatch(fetchproduct(productName)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateInvoiceSupplier);
